function initProductBadges() {
  window.productBadgeRules = [];

  const badgeData = document.getElementById("product-badges-data");

  if (badgeData) {
    try {
      window.productBadgeRules = JSON.parse(badgeData.textContent.trim());
    } catch (e) {
      console.error("Invalid badge JSON");
      window.productBadgeRules = [];
    }
  }

  const priorityOrder = [...new Set(
    window.productBadgeRules.map(rule => rule.type)
  )];

  const cards = document.querySelectorAll(".product-badges");
  if (!cards.length) {
    console.log("no cards");
    return;
  }

  cards.forEach(card => {
    card.querySelectorAll('.product-badge').forEach(b => b.remove());

    const d = card.dataset;

    const productId = Number(d.productId);
    const productType = d.productType;

    const inventory = Number(d.productInventory || 0);
    const isTracked = Number(d.inventoryTracked || 0) > 0;
    const isAvailable = d.available === "true";

    const continueSelling = d.continueSelling === "continue";

    const productTags = d.productTags ? d.productTags.split(",") : [];
    const productCollections = d.productCollections
      ? d.productCollections.split(",").map(Number)
      : [];

    let badgeToShow = null;

    for (let i = 0; i < priorityOrder.length && !badgeToShow; i++) {
      const type = priorityOrder[i];

      for (let j = 0; j < window.productBadgeRules.length; j++) {
        const rule = window.productBadgeRules[j];
        if (rule.type !== type) continue;

      const currentCollection = d.currentCollection ? Number(d.currentCollection) : null;

      if (rule.exclude_collections && rule.exclude_collections.length > 0) {
        if (currentCollection && rule.exclude_collections.includes(currentCollection)) {
          continue;
        }
      }

        let show = false;

        switch (rule.type) {
          case "tag-badge":
            show = rule.value.some(tag => productTags.includes(tag));
            break;

          case "type-badge":
            show = rule.value.includes(productType);
            break;

          case "product-badge":
            show = rule.value.includes(productId);
            break;

          case "on-sale-badge":
            const price = Number(d.productPrice);
            const comparePrice = Number(d.productComparePrice);

            show = comparePrice && price && comparePrice > price;
            break;

          case "collection-badge":

          if (rule.only_current_collection) {
            show = currentCollection && rule.value.includes(Number(currentCollection));
          } else {
              show = rule.value.some(id =>
                productCollections.includes(Number(id))
              );
            }

            break;

          case "inventory-badge":

            if (inventory <= 0) {
              show = false;
              break;
            }

            const value = Number(rule.value);
            if (rule.operator === "<") show = inventory < value;
            else if (rule.operator === ">") show = inventory > value;
            else if (rule.operator === "=") show = inventory === value;
            break;
        }

        if (show) {
          badgeToShow = rule;
          break;
        }
      }
    }

    if (badgeToShow) {
      const badge = document.createElement("span");
      badge.className = "product-badge";
      badge.textContent = badgeToShow.label;
      badge.style.color = badgeToShow.color;

      card.appendChild(badge);
      card.style.background = badgeToShow.background;
    }
  });
}

if (!window.productBadgeInitialized) {
  document.addEventListener("DOMContentLoaded", initProductBadges);
  window.productBadgeInitialized = true;
}